import React, { useState } from 'react'
import { Dialog } from 'functional-foundations'
import { makeStyles } from '@material-ui/core/styles'
import Picture from 'picture'
import MFAButton from '../components/elements/MFAButton'
import { PostMFASteps } from '../components/elements/MFAButton'
import { getRemoteValue } from './../utils'
import { Typography, Button } from 'foundations-library/components'
import { mfa, mfa_inline } from '../graphics'

const jss = (theme) => ({
    root: {
        '& > .dialog-container': {
            padding: '0',
            '& .dialog-content': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '80px'
            }
        }
    },
    content: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    picture: {
        width: '100%',
        '& img': {
            width: '100%',
            borderRadius: '20px'
        }
    },
    typographyContainer: {
        display: 'flex',
        paddingBottom: '30px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        alignSelf: 'stretch'
    },
    descriptionContainer: {
        textAlign: 'center',
        width: '60%',
        [theme.breakpoints.down('md')]: {
            width: '80%'
        }
    },
    buttonContainer: {
        display: 'flex',
        padding: '30px 0px 40px 0px',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '20px',
        alignSelf: 'stretch',
        borderRadius: '0px 0px 20px 20px',
        '& .loader--inner path': {
            fill: '#fff !important'
        }
    }
})

const useStyles = makeStyles(jss)

const texts = getRemoteValue('enable_mfa')

/**
 *
 */
const MFA = () => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(true)
    const [mfaCompleted, setMfaCompleted] = useState(false)
    const [mfaFailed, setMfaFailed] = useState(false)

    const handleEnableLater = () => {
        sessionStorage.setItem('remindMFAPopup-closed', 'true')
        setIsOpen(false)
    }

    const remindMFAPopupClosed = sessionStorage.getItem('remindMFAPopup-closed')
    if (remindMFAPopupClosed === 'true') return null

    return (
        <>
            <Dialog className={classes.root} isOpen={isOpen} data-testid={'mfa-dialog'}>
                <div className={classes.content} role='dialog'>
                    <Picture sources={[{ src: mfa, type: 'image/jpeg' }]} thumbnail={mfa_inline} alt='MFA graphic' attributes={{ className: classes.picture }} />
                    <div className={classes.typographyContainer}>
                        <Typography variant='h6'>
                            {texts.title}
                        </Typography>
                        <div className={classes.descriptionContainer}>
                            {texts.description.map((item, index) => (item.user === undefined) && (
                                <Typography display='inline' variant={item.type} color='neutral-700' key={index}>
                                    {item.value}
                                </Typography>
                            ))}
                        </div>
                    </div>
                    <div className={classes.buttonContainer}>
                        <Button variant='contained' color='neutral' size='large' onClick={handleEnableLater}>
                            {texts.enable_later_button}
                        </Button>
                        <MFAButton processPostMFA={false} onClick={() => { setIsOpen(false); setMfaCompleted(false) }} onSessionCompleted={() => { setMfaCompleted(true) }} onSessionFailed={() => { setMfaFailed(true) }}>
                            {texts.enable_button}
                        </MFAButton>
                    </div>
                </div>
            </Dialog>
            <PostMFASteps mfaCompleted={mfaCompleted} mfaFailed={mfaFailed} setMfaFailed={setMfaFailed} />
        </>
    )
}

export default MFA
